import { FC } from 'react';
import { Box, Button, ButtonAppearance, ButtonProps, ButtonSize } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const RodRequestCaddyStyled = styled(Box)`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
`;

export interface TabButtonProps extends ButtonProps {
  selected: boolean;
}
export const TabButtonStyled = styled(Button as FC<TabButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.LARGE,
})`
  width: auto;
  border: none;
  border-radius: 0;
  position: relative;
  &:focus {
    border-color: transparent;
    box-shadow: none;
  }
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    font-size: ${theme.fontSizes['300']};
    padding-left: ${theme.spacings[700]};
    padding-right: ${theme.spacings[700]};
    &::after {
      content: '';
      position: absolute;
      left: ${theme.spacings[450]};
      right: 0;
      bottom: 0;
      height: 5px;
      background-color: ${theme.colors.blue['700']};
      opacity: 0;
    }
  `};
  ${(props) =>
    props.selected &&
    css`
      font-weight: ${props.theme.fontWeights[600]};
      &::after {
        opacity: 1;
      }
    `};
`;

export const BoxStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: 1 },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[300]};
  `}
`;
